(function() {
	'use strict';

	angular
		.module('diplomaApp')
		.controller('bottomController', ['$scope', '$http', 'dpText', '$rootScope', '$interval', 'dpHelper', bottomController])
		.run(['$http', httpPostRepair]);


	function bottomController($scope, $http, dpText, $rootScope, $interval, dpHelper)
	{
		$scope.save = save;
		$scope.restart = restart;
		$scope.next = next;
		$scope.back = back;

		function save() {
			$http.post('/diplomovky/ajax/isLoggedIn')
				.then(isLoginComplete);

				function isLoginComplete(response) {
					var isLogin = (response.data === 'false') ? false : response.data;

					console.log(isLogin);

					if (isLogin) {
						$http.post('/diplomovky/ajax/saveOrder').then(isSaveOrder);
					} else {
						Alert.alert(dpText.get('DP_PRE_ULOZENIE_SA_MUSITE_PRIHLASIT'), dpText.get('DP_PRIHLASIT'), logUserIn);
					}
				}

				function isSaveOrder() {
					Alert.alert(dpText.get('DP_OBJEDNAVKA_BOLA_ULOZENA'));
				}

				function logUserIn() {
					window.location = '/login';
				}

			//isLoginComplete({data: false});
		}

		function restart($event) { 
			$event.preventDefault();
			var href = $($event.currentTarget).attr('href');

			Alert.confirm(dpText.get('DP_ZACAT_ODZNOVA_POPIS'), function(){
				window.location = href;
			});
		}

		function showErrors(errors, elements) {
			Alert.alert(errors, null, function() {
				$('.show-section-error').removeClass('show-section-error');

				var scrollTo = parseInt($(elements[0]).offset().top) - 20;
				$('html, body').animate({
			        scrollTop: scrollTo + 'px'
			    }, 1000, function(){
			    	$.each(elements, function(index, el) {
						$(el).addClass('show-section-error');
					});
			    });
			});
		}

		function next($event) {
			$event.preventDefault();
			$scope.href = $($event.currentTarget).attr('href');
			var formData = $rootScope.$$childHead.formData;
			if($('#frm-zasilkovna').length) {
				formData.zasilkovna = $('#frm-zasilkovna').val();
			}

			saveFormData(formData, function(){
				var checkName;

				switch (dpHelper.step) {
					case 1: checkName = 'checkIntroductionStep'; break;
					case 2: checkName = 'checkEditorStep'; break;
					case 3: checkName = 'checkAccessoryStep'; break;
				}

				if (dpHelper.step < 4) { 
					$http.post('/diplomovky/fast_ajax/' + checkName)
						.then(successCallback);

						function successCallback(response){
							var result = response.data;

							if (result.errors.length > 0) {
								showErrors(result.errors, result.error_elements);
							} else {
								if (dpHelper.step === 2) {
									if ($('.svg-editor-container')[0] && formData.binding !== 'unibind') {
										var svg = $('.svg-editor-container')[0].contentWindow.svg;
										var g = svg.getGlobalSpace();

										if (!svg.checkDiplomaTexts()) {
											var errors = $('.svg-editor-container')[0].contentWindow.$('.ve-diploma-errors div').html();
											Alert.alert(errors);
										} else if (g.overlappingLines && g.overlappingLines.length > 0) {
											$('.svg-editor-container')[0].contentWindow.$('.ve-diploma-errors p.green').remove();
											var errors = $('.svg-editor-container')[0].contentWindow.$('.ve-diploma-errors div').html();
											
											Alert.confirm(errors, function(){
												svg.saveSVG(onSvgSave);
											});
										} else {
											svg.saveSVG(onSvgSave);
										}
									}

									//iframe je schovaný a počet riadkov zadáva operátor
									if (!$('.svg-editor-container')[0] && formData.binding !== 'unibind') {
										Session.get('text_lines_count', function(count) {
											if (count < 5) {
												Alert.confirm(dpText.get('DP_2_JE_ZADANY_MALY_POCET_RIADKOV'), function(){
													window.location = $scope.href;
												});
											} else {
												window.location = $scope.href;
											}
										});
									}

									if (formData.binding === 'unibind') {
										window.location = $scope.href;
									}
								} else {
									window.location = $scope.href;
								}
							}
						}
				} else {
					window.location = $scope.href;
				}
			});
		}

		function onSvgSave() {
			setTimeout(function () {
				window.location = $scope.href;
			}, 1500);
		}

		function back($event) {
			$event.preventDefault();
			var href = $($event.currentTarget).attr('href');
			var formData = $rootScope.$$childHead.formData;

			saveFormData(formData, function(){
				window.location = href;
			});
		}

		function saveFormData(formData, onSave) {
			Session.set(formData, null, function(){
				if (typeof onSave === 'function') {
					onSave();
				}
			});
		}

		function initialize() {
			PriceTable.getData();
			Session.keepSessionAlive();
			/*
			 * Vypnuté aby nezaťažovalo session
			 */
			// $interval(function(){
			// 	var formData = jQuery.extend(true, {}, $rootScope.$$childHead.formData);
			// 	delete formData.session_id;
			// 	saveFormData(formData);
			// }, 1000*60);
		}

		/*
			Initialize
		 */
		angular.element(document).ready(function () {
			initialize();
	    });
	}

	function httpPostRepair($http)
	{
		// Use x-www-form-urlencoded Content-Type
		$http.defaults.headers.post = {'Content-Type' : 'application/x-www-form-urlencoded'};
	}
}());
